import { takeLatest, put, call, fork } from 'redux-saga/effects';
import callApi from 'utils/api';
import getCOPScookie from 'utils/cookies';
import * as actionTypes from './constants';

import { fetchNewsSuccess, fetchNewsFailure } from './news-actions';

export function* fetchNews(action) {
  try {
    const results = yield call(callApi, {
      endpoint: `feed.json?t=${Date.now()}`,
      options: {
        api: getCOPScookie('HelpUrl') || HELP_URL,
        errorMessage: 'Could not get dashboard news',
        retryAction: action,
      },
    });
    yield put(fetchNewsSuccess(results));
  } catch (err) {
    yield put(fetchNewsFailure(err));
  }
}

function* watchGetNews() {
  yield takeLatest(actionTypes.NEWS_REQUEST, fetchNews);
}

export default [fork(watchGetNews)];
